export enum BloodProductAdministrationConstants {
  SET_PT_ID_VERIFIED = 'bloodProductAdministration/SET_PT_ID_VERIFIED',
  SET_WITNESS1 = 'bloodProductAdministration/SET_WITNESS1',
  SET_WITNESS2 = 'bloodProductAdministration/SET_WITNESS2',
  SET_CLINICAL_INDICATORS = 'bloodProductAdministration/SET_CLINICAL_INDICATORS',
  SET_TRANSFUSION_CONSENT = 'bloodProductAdministration/SET_TRANSFUSION_CONSENT',
  SET_TRANSFUSION_CONSENT_DATE = 'bloodProductAdministration/SET_TRANSFUSION_CONSENT_DATE',
  SET_TRANSFUSION_CONSENT_TIME = 'bloodProductAdministration/SET_TRANSFUSION_CONSENT_TIME',
  SET_TRANSFUSION_CONSENT_DATE_TIME = 'bloodProductAdministration/SET_TRANSFUSION_CONSENT_DATE_TIME',
  SET_BLOOD_PRODUCT = 'bloodProductAdministration/SET_BLOOD_PRODUCT',
  SET_BLOOD_PRODUCT_TYPE = 'bloodProductAdministration/SET_BLOOD_PRODUCT_TYPE',
  SET_PRODUCT_ID = 'bloodProductAdministration/SET_PRODUCT_ID',
  SET_UNIT_EXPIRY_DATE = 'bloodProductAdministration/SET_UNIT_EXPIRY_DATE',
  SET_UNIT_EXPIRY_TIME = 'bloodProductAdministration/SET_UNIT_EXPIRY_TIME',
  SET_UNIT_EXPIRY_DATE_TIME = 'bloodProductAdministration/SET_UNIT_EXPIRY_DATE_TIME',
  SET_SITE_ADMINISTERED = 'bloodProductAdministration/SET_SITE_ADMINISTERED',
  SET_TRANSFUSION_START_DATE = 'bloodProductAdministration/SET_TRANSFUSION_START_DATE',
  SET_TRANSFUSION_START_TIME = 'bloodProductAdministration/SET_TRANSFUSION_START_TIME',
  SET_TRANSFUSION_START_DATE_TIME = 'bloodProductAdministration/SET_TRANSFUSION_START_DATE_TIME',
  SET_TRANSFUSION_END_DATE = 'bloodProductAdministration/SET_TRANSFUSION_END_DATE',
  SET_TRANSFUSION_END_TIME = 'bloodProductAdministration/SET_TRANSFUSION_END_TIME',
  SET_TRANSFUSION_END_DATE_TIME = 'bloodProductAdministration/SET_TRANSFUSION_END_DATE_TIME',
  SET_VOLUME_INFUSED = 'bloodProductAdministration/SET_VOLUME_INFUSED',
  SET_VOLUME_INFUSED_UNIT = 'bloodProductAdministration/SET_VOLUME_INFUSED_UNIT',
  SET_UNIT_COMPLETED = 'bloodProductAdministration/SET_UNIT_COMPLETED',
  SET_WARMER_USED = 'bloodProductAdministration/SET_WARMER_USED',
  SET_TRANSFUSION_ORDER = 'bloodProductAdministration/SET_TRANSFUSION_ORDER',
  SET_ROUTE = 'bloodProductAdministration/SET_ROUTE',
  SET_CROSS_MATCHED = 'bloodProductAdministration/SET_CROSS_MATCHED',
  SET_IMPLIED_EMERGENT_CONSENT_REASON = 'bloodProductAdministration/SET_IMPLIED_EMERGENT_CONSENT_REASON',
  NOT_IMPLEMENTED = 'bloodProductAdministration/NOT_IMPLEMENTED',
  SET_RESPONSE = 'bloodProductAdministration/SET_RESPONSE',
  SET_RESPONSE_PNNV = 'bloodProductAdministration/SET_RESPONSE_PNNV',
  SET_PTA = 'bloodProductAdministration/SET_PTA',
  SAVE_BLOOD_PRODUCT_ADMINISTRATION = 'bloodProductAdministration/SAVE_BLOOD_PRODUCT_ADMINISTRATION',
  RESET_STATE = 'bloodProductAdministration/RESET_STATE',
  SET_ADD_TO_TIMELINE = 'bloodProductAdministration/SET_ADD_TO_TIMELINE',
  SET_STATE = 'bloodProductAdministration/SET_STATE',
  SET_DATE_TIME = 'bloodProductAdministration/SET_DATE_TIME',
  SET_ASSESSED_BY = 'bloodProductAdministration/SET_ASSESSED_BY',
  ON_SELECT_BLOOD_PRODUCT_ADMINISTRATION = 'bloodProductAdministration/ON_SELECT_BLOOD_PRODUCT_ADMINISTRATION',
  SET_UPDATE_INPUT_ROWS = 'bloodProductAdministration/SET_UPDATE_INPUT_ROWS',
  SET_DATE = 'bloodProductAdministration/SET_DATE',
  SET_TIME = 'bloodProductAdministration/SET_TIME',
  SET_ATTEMPTS = 'bloodProductAdministration/SET_ATTEMPTS',
  SET_PROCEDURE_COMPLICATIONS = 'bloodProductAdministration/SET_PROCEDURE_COMPLICATIONS',
  SET_SUCCESSFUL_ATTEMPT = 'bloodProductAdministration/SET_SUCCESSFUL_ATTEMPT',
  SET_COMMENTS = 'bloodProductAdministration/SET_COMMENTS',
  SET_ROLE_PERFORMING = 'bloodProductAdministration/SET_ROLE_PERFORMING',
  SET_ROLE_PERFORMING_PNNV = 'bloodProductAdministration/SET_ROLE_PERFORMING_PNNV',
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT = 'bloodProductAdministration/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT',
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV = 'bloodProductAdministration/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV',
  VOLUME_INFUSED_UNIT = 'ml',
}
